/* eslint-disable max-classes-per-file */
import { ValidationContext } from "../../../../common/validation/validationContext";
import { ValidationErrorLevels } from "../../../../common/validation/ValidationErrorLevels";
import { ValidationScopes } from "../../../../common/validation/ValidationScopes";
import { JlpKundorderSearchModel } from "../models/jlp-kundorder.model";
import { JlpLeverantorsorderSearchModel } from "../models/jlp-leverantorsoder-model";
import { JlpProduktionsomradenSearchModel } from "../models/jlp-produktionsomrade-model";
import { JlpValidationTexts as text } from "./jlp-validation-texts";

export class KundorderValidation {
    static init(kundorder: JlpKundorderSearchModel): ValidationContext {
        const context = new ValidationContext();
        context.create(ValidationScopes.sok).withRulesWhen(() => kundorder !== null, [
            {
                errorLevel: ValidationErrorLevels.error,
                id: "2",
                message: { text: text.validation.mandatory },
                model: () => kundorder.periodFrom,
                name: "periodFrom",
                required: true
            },
            {
                errorLevel: ValidationErrorLevels.error,
                id: "3",
                message: { text: text.validation.mandatory },
                model: () => kundorder.periodTom,
                name: "periodTom",
                required: true
            }
        ]);
        return context;
    }
}

export class LeverantorsorderValidation {
    static init(levorder: JlpLeverantorsorderSearchModel): ValidationContext {
        const context = new ValidationContext();
        context.create(ValidationScopes.sok).withRulesWhen(() => levorder !== null, [
            {
                errorLevel: ValidationErrorLevels.error,
                id: 2,
                message: { text: text.validation.mandatory },
                model: () => levorder.periodFrom,
                name: "periodFrom",
                required: true
            },
            {
                errorLevel: ValidationErrorLevels.error,
                id: 3,
                message: { text: text.validation.mandatory },
                model: () => levorder.periodTom,
                name: "periodTom",
                required: true
            }
        ]);
        return context;
    }
}

export class ProduktionsomradenValidation {
    static init(produktionsomrade: JlpProduktionsomradenSearchModel): ValidationContext {
        const context = new ValidationContext();
        context.create(ValidationScopes.sok).withRulesWhen(() => produktionsomrade !== null, [
            {
                errorLevel: ValidationErrorLevels.error,
                id: 2,
                message: { text: text.validation.mandatory },
                model: () => produktionsomrade.periodFrom,
                name: "periodFrom",
                required: true
            },
            {
                errorLevel: ValidationErrorLevels.error,
                id: 3,
                message: { text: text.validation.mandatory },
                model: () => produktionsomrade.periodTom,
                name: "periodTom",
                required: true
            }
        ]);
        return context;
    }
}
